// extracted by mini-css-extract-plugin
export default {"wrapper":"Error_wrapper__DjcOU","header":"Error_header__mMwwI","message":"Error_message__KoPyG","stack":"Error_stack__W-IFb","buttons":"Error_buttons__CrUEc"};